import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { PaginationInfo } from "components/CRPComponents/Tables/GenericTable/types";

export const GET_ALL_QUERY = print(gql`
  query TemplateInvestments($page: Int, $perPage: Int, $search: String, $active: Boolean) {
    TemplateInvestments(page: $page, perPage: $perPage, search: $search, active: $active) {
      items {
        id
        active
        name
        allowPurchase
        maxAdmissionWays
        maxPlans
        maxAmountInstallmentsPrices
      }
      paginationInfo {
        page
        perPage
        hasMore
        totalPages
        totalData
        nextPage {
          page
          perPage
        }
      }
    }
  }
`);

/** Type each item in response data*/
export interface GetAllItem {
  id: number;
  active: boolean;
  name: string;
  allowPurchase: boolean;
  allowGift: boolean;
  maxAdmissionWays?: number;
  maxPlans?: number;
  maxAmountInstallmentsPrices?: number;
}

export const responseGetAllKey = "TemplateInvestments";

/** Type response data */
export interface GetAllGql {
  TemplateInvestments: {
    items: GetAllItem[];
    paginationInfo: PaginationInfo;
  };
}
